import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { server, files } from "../configs";
import { Context } from "../GlobalContext";
import Axios from "axios";
import Swal from "sweetalert2";
import "../global/pages.css";
import "./Greeting.css";
import "./Info.css";

const VersionBase64 = ({ match, history }) => {
  const [one, setOne] = useState(true);
  const [isLoaded, setLoaded] = useState(false);
  const [govData, setGovData] = useState(null);
  const [target, setTarget] = useState(null);
  const [targetList, setTargetList] = useState([]);

  useEffect(() => {
    const { base } = match.params;

    console.log(base)

    const [gov, index] = atob(base).split('/');

    if (gov) {
      Axios.get(
        server +
          `/v2/govs/${gov}/institutes?name=&page=0&size=9999&sort=,`
      )
        .then(({ data }) => {
          console.log(index, data);
          const list = data.inst.content.find(
            (x) => x.id == index
          ).subjectTypes;

          console.log(list);
          setTargetList(list);
          setGovData(data.gov);
        })
        .catch((e) => {
          console.log(e);
        });
    }

    setLoaded(true);
  }, []);

  function _hasJong(string) {
    //string의 마지막 글자가 받침을 가지는지 확인
    string = string.charCodeAt(string.length - 1);
    return (string - 0xac00) % 28 > 0;
  }

  const onNextHandler = () => {
    if (target !== null) {
      Swal.fire({
        title: "확인해 주세요!",
        confirmButtonText: "네",
        confirmButtonColor: "#00aeef",
        showCancelButton: true,
        cancelButtonText: "아니요",
        cancelButtonColor: "#d33",
        text: `선택한 대상이 ${
          _hasJong(target.subjectType.name)
            ? `${target.subjectType.name}이`
            : `${target.subjectType.name}가`
        } 맞나요?`,
        heightAuto: false,
      }).then((result) => {
        if (result.isConfirmed) {
          console.log(1);
          history.replace(`/${target.id}`);
        }
      });
    }
  };

  if (one) {
    return (
      govData && (
        <div className="container" id="greeting__container">
          <div className="logo" id="greeting__logo">
            <img src={govData.logoUrl} alt="state logo" />
          </div>
          <div id="greeting__content">
            <img
              src={govData.introduction}
              alt="아동이 살기 좋은 우리 동네 만들기"
            />
          </div>
          <div className="next-button">
            <Link
              to={"#"}
              className="btn big-btn"
              alt="시작하기 버튼"
              onClick={(e) => {
                e.preventDefault();
                setOne(false);
              }}
            >
              <span>시작하기</span>
            </Link>
          </div>
          <div className="notice-wrap">
            <div className="notice">
              <img
                src={
                  "https://tsukuru-inquiry-backend.s3.ap-northeast-2.amazonaws.com/images/info.svg"
                }
                alt="info"
              />
              <span>
                진행과 관련하여 궁금한 점은 02-780-0116으로 연락 하십시오.
                아동참여 플랫폼 관련 궁금한 점이 있다고 말씀하시면 담당자가
                친절히 안내해 드리겠습니다.
                <br />
                (안내시간 | 주중 09:00~18:00)
              </span>
            </div>
            <div className="notice">
              <img src={files + "/chrome.svg"} alt="크롬 브라우저" />
              <span>
                본 웹사이트는 크롬 브라우저에 최적화되어있습니다.
                <br />
                <a
                  href="https://www.google.com/intl/ko/chrome/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  크롬 브라우저 다운받기
                </a>
              </span>
            </div>
          </div>
        </div>
      )
    );
  }

  return (
    isLoaded && (
      <div className="container" id="info__container">
        <div className="title" id="info__title">
          <div className="icon">
            <img src={files + "/talk.svg"} alt="참여를 위한 기본 정보" />
          </div>
          <h3>참여를 위한 기본 정보</h3>
        </div>
        <div className="content" id="info__content">
          <p>
            참가하시는 분의 일반적인 특징에 응답해 주세요.
            <br />
            <br />
            14세 미만의 참가자는 보호자로부터 도움을 받으시기 바랍니다.
          </p>
          <div className="info-box">
            <div className="question first-page">
              <b>조사 대상을 선택해 주세요.</b>
              <div className="red-dot" />
              <ul className="target-list">
                {targetList?.length > 0 &&
                  targetList?.map((item, i) => (
                    <li
                      key={i}
                      value={item.id}
                      className={`target-item ${
                        target?.id === item.id && "active"
                      }`}
                      onClick={() => {
                        setTarget(item);
                      }}
                    >
                      {item.subjectType.name}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="link-buttons">
          <button style={{ display: "none" }} />
          <button
            className="link-btn"
            onClick={onNextHandler}
            alt="다음으로 버튼"
            disabled={target === null}
          >
            다음으로
          </button>
        </div>
      </div>
    )
  );
};

export default VersionBase64;
